
import { 
  Sidebar,
  SidebarContent,
  SidebarProvider,
  SidebarRail,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { dashboardItems } from "../navigation/NavItems";
import { SidebarHeader } from "./SidebarHeader";
import { SidebarMenu } from "./SidebarMenu";
import { SidebarFooter } from "./SidebarFooter";
import { PanelLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";

interface SidebarProps {
  children: React.ReactNode;
}

// A floating button to re-open the sidebar when it's collapsed
const FloatingSidebarButton = () => {
  const { open, setOpen, state } = useSidebar();
  
  if (state !== "collapsed") return null;
  
  return (
    <Button 
      variant="outline"
      size="icon"
      className="fixed left-4 top-4 z-50 rounded-full bg-white shadow-md border border-gray-200"
      onClick={() => setOpen(true)}
    >
      <PanelLeft className="h-4 w-4" />
      <span className="sr-only">Open sidebar</span>
    </Button>
  );
};

export function DashboardSidebar({ children }: SidebarProps) {
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="flex min-h-screen w-full">
        <Sidebar className="border-r border-gray-800 bg-sidebar">
          <SidebarHeader />
          
          <SidebarContent>
            <SidebarMenu items={dashboardItems} />
          </SidebarContent>
          
          <SidebarFooter />
          
          {/* Add the sidebar rail for a better resize experience */}
          <SidebarRail />
        </Sidebar>
        
        <div className="flex-1 bg-background text-foreground">
          <FloatingSidebarButton />
          {children}
        </div>
      </div>
    </SidebarProvider>
  );
}
